export enum HttpStatusEnum {
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  InternalServer = 500
}

export enum HttpErrorMessageEnum {
  InvalidToken = 'INVALID_TOKEN',
  AccountNotFound = 'ACCOUNT_NOT_FOUND'
}
